<template>
    <div id="container">
        <keep-alive include="library">
            <router-view :key="refreshKey" />
        </keep-alive>
        <!-- <button @click="handleRefresh" class="fixed bottom-8 right-8 bg-neutral-content hover:bg-accent hover:text-accent-content text-neutral font-bold py-2 px-4 rounded-full shadow-xl transition-colors duration-300">
            <svg class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M896 192v110.72A448 448 0 0 0 544 128 455.04 455.04 0 0 0 128 403.2l64 25.6A391.04 391.04 0 0 1 544 192a388.48 388.48 0 0 1 330.88 192H704v64h256V192zM544 832a388.48 388.48 0 0 1-330.88-192H384V576H128v256h64v-110.72A448 448 0 0 0 544 896 455.04 455.04 0 0 0 960 620.8l-64-25.6A391.04 391.04 0 0 1 544 832z"></path>
            </svg>
        </button> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                refreshKey: 0
            }
        },
        mounted() {
            // 监听全局刷新事件
            this.$root.$on('refresh-page', this.handleRefresh)
        },
        beforeDestroy() {
            // 组件销毁前移除事件监听
            this.$root.$off('refresh-page', this.handleRefresh)
        },
        methods: {
            handleRefresh() {
                this.refreshKey += 1
            }
        }
    }
</script>

<style scoped>
</style>
